import { render, staticRenderFns } from "./BaseDynamicLoader.vue?vue&type=template&id=15931b14&scoped=true"
import script from "./BaseDynamicLoader.vue?vue&type=script&lang=js"
export * from "./BaseDynamicLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseDynamicLoader.vue?vue&type=style&index=0&id=15931b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15931b14",
  null
  
)

export default component.exports